export * from './equipments-list.component';
